import { all, takeEvery, call, put } from 'redux-saga/effects';
import actions from './actions';
import clientActions from '../clients/actions';
import { getClients, postClient } from '../../../api/clients/clients.api';
import { message } from 'antd';

function* fetchAccounts() {
  try {
    const accounts = yield call(getClients, { type: 'ACCOUNT' });
    yield put(actions.fetchAccountsSuccess(accounts));
  } catch (error) {
    console.log(error);
  }
}

function* selectAccount(accountId) {
  try {
    const clientObj = yield call(getClients, { clientId: accountId });
    yield put(actions.selectAccountSuccess(clientObj.client[0]));
  } catch (error) {
    console.log(error);
  }
}

function* addAccount({ account }) {
  try {
    const { client = {} } = yield call(postClient, { client: account, type: 'ACCOUNT' });
    yield put(actions.addAccountSuccess(client));
    yield put(actions.switchAccount(client.clientId));
    yield put(clientActions.fetchClients(client.clientId));
    yield message.success(`Account ${client.name} added successfully`);
  } catch (error) {
    yield message.error(`Unable to add account! Please try later.`);
    yield put(actions.addAccountError());
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOGIN_FINISHED, fetchAccounts),
    takeEvery(actions.FETCH_ACCOUNTS, fetchAccounts),
    takeEvery(actions.SELECT_ACCOUNT, selectAccount),
    takeEvery(actions.ADD_ACCOUNT, addAccount),
  ]);
}
